var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDisplayMedicalDuotoneSolid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 50,
    viewBox: "0 0 57 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "display-medical-duotone-solid 1",
    clipPath: "url(#clip0_175_4076)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.5 6.25V34.375C0.5 37.8223 3.29028 40.625 6.72222 40.625H23.8333H33.1667H50.2778C53.7097 40.625 56.5 37.8223 56.5 34.375V6.25C56.5 2.80273 53.7097 0 50.2778 0H6.72222C3.29028 0 0.5 2.80273 0.5 6.25ZM6.72222 6.25H50.2778V34.375H6.72222V6.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.72217 6.25H50.2777V34.375H6.72217V6.25ZM34.2069 43.75H40.9444C42.6652 43.75 44.0555 45.1465 44.0555 46.875C44.0555 48.6035 42.6652 50 40.9444 50H16.0555C14.3347 50 12.9444 48.6035 12.9444 46.875C12.9444 45.1465 14.3347 43.75 16.0555 43.75H22.793L23.8333 40.625H33.1666L34.2069 43.75ZM25.3888 12.5V17.1875H20.7222C19.8666 17.1875 19.1666 17.8906 19.1666 18.75V21.875C19.1666 22.7344 19.8666 23.4375 20.7222 23.4375H25.3888V28.125C25.3888 28.9844 26.0888 29.6875 26.9444 29.6875H30.0555C30.9111 29.6875 31.6111 28.9844 31.6111 28.125V23.4375H36.2777C37.1333 23.4375 37.8333 22.7344 37.8333 21.875V18.75C37.8333 17.8906 37.1333 17.1875 36.2777 17.1875H31.6111V12.5C31.6111 11.6406 30.9111 10.9375 30.0555 10.9375H26.9444C26.0888 10.9375 25.3888 11.6406 25.3888 12.5Z",
    fill: "url(#paint0_linear_175_4076)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_175_4076",
    x1: 7.08037,
    y1: 50,
    x2: 59.1056,
    y2: 28.9031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47E4A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4CCEDD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_175_4076"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 50,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDisplayMedicalDuotoneSolid);
export default __webpack_public_path__ + "static/media/icon-display-medical-duotone-solid.32e09348eae1eae0ca74d8c1b878fdc7.svg";
export { ForwardRef as ReactComponent };